<template>
    <ImageGallery :images="images" class="netto-image-gallery">
        <template v-slot:prev="slotProps">
            <button class="button-prev" @click.prevent="slotProps.click" title="vorheriges Foto">
                <svg class="icon-prev">
                    <use :xlink:href="leftIcon + '#icon_arrow-left'"></use>
                </svg>
            </button>
        </template>
        <template v-slot:next="slotProps">
            <button class="button-next" @click.prevent="slotProps.click" title="nächstes Foto">
                <svg class="icon-next">
                    <use :xlink:href="leftIcon + '#icon_arrow-left'"></use>
                </svg>
            </button>
        </template>
    </ImageGallery>
</template>

<script>
import ImageGallery from '@/components/product/ImageGallery';
import leftIcon from '@/themes/nettovorteilswelt/assets/icons/icon_arrow-left.svg';

export default {
    name: 'NettoImageGallery',
    data() {
        return {
            leftIcon
        };
    },
    components: {
        ImageGallery
    },
    props: {
        images: Array
    }
};
</script>

<style scoped lang="scss">
@use '../../styles/variables' as theme;

.button-prev,
.button-next {
    border: 2px solid theme.$primary !important;
    background-color: hsl(0, 0%, 100%) !important;
}

.icon-next,
.icon-prev {
    width: 34px;
    height: 34px;
    display: block;
}

.icon-next {
    transform: rotate(180deg);
}

.netto-image-gallery ::v-deep {
    .image-gallery__active-wrapper {
        margin-bottom: 15px;
    }

    .image-gallery__thumbnails {
        grid-gap: 15px;
        grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
    }

    .image-gallery__thumbnail {
        height: 100px;
        outline: 1px solid theme.$primary;
    }
}
</style>
